import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const URL = 'https://app.inforida.com/api'; // this is the url
const tryItUrl = 'https://tryit.inforida.com/api';

@Injectable({
  providedIn: 'root',
})
export class NewPageService {
  // schoolId: string = 'sfa';
  // private apiUrl = 'https://ourapi/school-data';

  constructor(private http: HttpClient) {}

  getSchoolBySlug(slug: string): Observable<any> {
    return this.http.get(`${URL}/school/getBySlug/${slug}`); // this is new
  }

  getSchoolFromAdmnId(admnId: string): Observable<any> {
    return this.http.get(`${URL}/school/getSchoolFromAdmissionId/${admnId}`); // this can be tryIt
  }

  createAdmissionEnquiry(data: any) {
    const toCall = `${URL}/school/createAdmissionEnquiry`;
    return this.http.post(toCall, data);
  }

  getSpecificAdmissionEnquiry(admissionId: string): Observable<any> {
    return this.http.get(
      `${URL}/school/getSpecificAdmissionEnquiry/${admissionId}` // thus can be tryIt
    );
  }

  recordSchoolPageVisit(data: any) {
    const toCall = `${URL}/school/recordSchoolPageVisit`;
    return this.http.post(toCall, data);
  }

  getBlob(url) {
    return this.http.get(url, { responseType: 'blob' });
  }
  // getSchoolData(): Observable<any> {
  //   return this.http.get<any>(`${this.apiUrl}/${this.schoolId}`);
  // }
}
